import React from 'react';

import Input from '../../../elements/forms/Input';
import OptionsQuestion from './OptionsQuestion';

export default class Question extends React.Component {
    render() {
        let {event, question} = this.props,
            commonProps = {
                onChange: this.props.onChange,
                placeholder: question.label + (question.required ? '*': ''),
                value: this.props.value || ''
            },
            field;

        console.log(question);
        switch (question.type) {
            case 'numeric':
                field = <Input type="number" {...commonProps}/>;
                break;
            case 'textline':
                field = <Input type="text" {...commonProps}/>;
                break;
            case 'text':
                field = <Input type="textarea" {...commonProps}/>;
                break;
            case 'phone':
                field = <Input type="tel" {...commonProps}/>;
                break;
            case 'email':
                field = <Input type="email" {...commonProps}/>;
                break;
            case 'link':
                field = <Input type="url" {...commonProps}/>;
                break;
            case 'options':
                field = <OptionsQuestion event={event} question={question} questions={this.props.questions} value={this.props.value} onChange={this.props.onChange} formAnswer={this.props.formAnswer} key={question.id} />;
                break;
            default:
                console.error('Unsupported question type: ', question.type);
        }

        return <div className={"EventForm--Question "+(this.props.hasError ? 'has-error': '')}>{field}</div>;
    }
}
